module.exports = __webpack_public_path__ + "static/media/bg-card-home.305e90fb.svg";